import { render, staticRenderFns } from "./Ecosystems.vue?vue&type=template&id=3b972a4b&scoped=true"
import script from "./Ecosystems.vue?vue&type=script&setup=true&lang=js"
export * from "./Ecosystems.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b972a4b",
  null
  
)

export default component.exports